import classNames from 'classnames';
import React, { CSSProperties, PropsWithChildren } from 'react';
import useDrawer from './useDrawer';

interface Props extends PropsWithChildren {
  minHeight?: number;
}

const Drawer = ({ children, minHeight = 130 }: Props) => {
  const {
    height,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
    wrapperRef,
    dragDirection,
    maxHeight,
  } = useDrawer(minHeight, 300);

  const style = {
    '--drawer-offset': `${height}px`,
    '--drawer-max-height': `${maxHeight}px`,
  } as CSSProperties;

  return (
    <div
      className={classNames('drawer', {
        'drawer--dragging': Boolean(dragDirection),
      })}
      style={style}
      ref={wrapperRef}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div className="drawer__handle" />
      {children}
    </div>
  );
};

export default Drawer;
